import { Button } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	.MuiIconButton-root.Mui-disabled {
		color: ${({ theme }) => theme.icon} !important;
	}
`;

export const SupplierName = styled.h4``;

export const TooltipText = styled.p`
	margin: 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	width: 100%;
	max-width: 300px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		max-width: 230px;
	}
`;

export const ContainerSupplier = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

export const BoxImagePart = styled.div`
	img {
		width: 100%;
		max-width: 75px;
		max-height: 75px;
		min-width: 75px;
		min-height: 75px;
		object-fit: contain;
	}
`;

export const ContainerPart = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Column = styled.div<{ customWidth: string }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;

	& > *:nth-child(1) {
		width: 23%;
	}

	& > *:nth-child(2) {
		margin-top: 15px;
		width: 50%;
	}

	& > *:nth-child(3) {
		width: 10%;
	}

	& > *:nth-child(4) {
		width: 16%;
	}

	& > *:nth-child(5) {
		width: ${(props) => props.customWidth};
	}
`;

export const Quantity = styled.div`
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 20%;
	margin: 0 auto;
`;

export const ButtonImage = styled(Button)`
	&&& {
		background: none;
		border: none;
		min-width: fit-content;
	}
`;

export const Footer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 1rem;
	width: 100%;
`;
